<template>
  <div class="col cardBox itembox" style="align-items: center">
    <card
      :title="cardBoxTitle"
      :styles="'small overflow-none'"
      :icon="{ class: 'scf-vector', styles: 'padding:5px;' }"
      :enableCollapse="false"
      :withBody="false"
      :fullScreen="false"
    >
    </card>
  </div>
</template>

<script>
import card from "@supervision/vue-components/components/Card.vue";
export default {
  name: "CardBox",
  components: { card },
  props: {
    type: {
      type: String,
      required: true,
    },
    identifier: {
      type: String,
      required: true,
    },
  },
  computed: {
    cardBoxTitle() {
      
      if (!this.$props.type || !this.translationExists('pages.DeviceDetails.' + this.$props.type))
        return "";
      return this.$t('pages.DeviceDetails.' + this.$props.type).concat(' ', this.$props.identifier);
    }
  },
  methods: {
    translationExists(e) {
      return typeof this.$tm(e) == "string";
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  position: relative;
  top: 3px;
  font-size: 20px;
  margin-right: 15px;
}
.titleCardBox {
  font-family: D-DIN !important;
  // font-style: normal !important;
  font-size: 16px;
}
.cardBox {
  font-family: D-DIN !important;
  border: 0px solid #030f40 !important;
}
.itembox {
  box-sizing: border-box;

  height: 49px;

  /* Charte Suez/Gris clair Suez */

  /* Blue legacy */

  border: 0px solid #030f40;

  margin-left: 10px;
  /* Inside auto layout */
}
</style>

<style lang="css">
@import "../../node_modules/@suez/custom-icons/suez-glyphicons.css";
@import "../../node_modules/bootstrap/dist/css/bootstrap.css";
</style>
